import { SUPPORT_EMAIL } from "./constants";

export class UserFacingError extends Error {
  constructor(
    message: string,
    public readonly statusCode?: number,
  ) {
    super(message);
    this.name = "UserFacingError";
  }
}

const STATUS_MESSAGES: Record<number, string> = {
  400: "Некорректный запрос. Проверьте введённые данные.",
  401: "Сессия истекла. Пожалуйста, войдите снова.",
  403: "Доступ запрещён.",
  404: "Запрашиваемый ресурс не найден.",
  409: "Конфликт данных. Попробуйте обновить страницу.",
  413: "Файл слишком большой.",
  422: "Некорректные данные. Проверьте заполненные поля.",
  429: "Слишком много запросов. Попробуйте позже.",
  500: `Внутренняя ошибка сервера. Попробуйте позже или свяжитесь с поддержкой: ${SUPPORT_EMAIL}`,
  502: "Сервер временно недоступен. Попробуйте позже.",
  503: "Сервис на обслуживании. Попробуйте позже.",
  504: "Сервер не отвечает. Попробуйте позже.",
};

const GENERIC_ERROR = `Произошла ошибка. Попробуйте позже или свяжитесь с поддержкой: ${SUPPORT_EMAIL}`;

export function toUserFacingError(status: number, serverMessage?: string): UserFacingError {
  const message = serverMessage || STATUS_MESSAGES[status] || GENERIC_ERROR;
  return new UserFacingError(message, status);
}
